import VisibilityIcon from './VisibilityIcon'

export default VisibilityIcon
